export default "__VITE_ASSET__BXyXkjZg__"